import moment from 'moment';

import {
  SET_LOADING_STATUS,
  GET_USER_PROFILE,
  SET_USER_SETTINGS,
  SET_USER_SETTING,
  CLEAR_USER_PROFILE,
  SET_ORIGINAL_PROFILE,
} from '../actions/Auth';
import { SET_CLIENT_USAGE } from '../actions/Clients';

const initialState = {
  profile: null,
  originalProfile: null,
  loading: false,
};

export const Auth = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING_STATUS:
      return Object.assign({}, state, {
        loading: action.loading,
      });

    case GET_USER_PROFILE: {
      if (action.profile.language) {
        moment.locale(action.profile.language);
      }
      return Object.assign({}, state, {
        profile: action.profile,
      });
    }

    case SET_USER_SETTINGS:
      return Object.assign({}, state, {
        profile: Object.assign({}, state.profile, {
          settings: action.settings,
        }),
      });

    case SET_USER_SETTING:
      return Object.assign({}, state, {
        profile: Object.assign({}, state.profile, {
          settings: Object.assign({}, state.profile.settings, action.setting),
        }),
      });

    case CLEAR_USER_PROFILE:
      return Object.assign({}, state, {
        profile: null,
      });

    case SET_ORIGINAL_PROFILE:
      return Object.assign({}, state, {
        originalProfile: action.profile,
      });

    case SET_CLIENT_USAGE:
      return Object.assign({}, state, {
        profile: Object.assign({}, state.profile, {
          client: Object.assign({}, state.profile.client, {
            used_storage: action.usage.used_storage,
            unused_storage: action.usage.unused_storage,
            used_storage_percentage: action.usage.used_storage_percentage,
          }),
        }),
      });

    default:
      return state;
  }
};
